import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
export function ConfirmDialog({ message, onClose, ...props }) {
    return (<Dialog {...props} fullWidth maxWidth={'md'}>
      <DialogTitle>{props.title}</DialogTitle>
      {message && <DialogContent>{message}</DialogContent>}
      <DialogActions>
        <Button type='button' onClick={() => onClose(false)}>
          Cancelar
        </Button>
        <Button onClick={() => {
            onClose(true);
        }} variant='contained'>
          OK
        </Button>
      </DialogActions>
    </Dialog>);
}
